module.exports = __webpack_public_path__ + "static/img/brees-2001-slide-4.2a44a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-slide-4.jpg
// module id = lkiO
// module chunks = 1